(() => {
  'use strict';

  const root = document.querySelector('[data-innungsprofil-verzeichnis]');
  const sourceRoot = document.querySelector('[data-zb-directory]');
  if (!root || !sourceRoot) return;

  const wantedTitle = String(root.dataset.profileTitle || '').trim();
  const profileType = String(root.dataset.profileType || 'INNUNG').trim();
  const loading = root.querySelector('[data-ipv-loading]');
  const errorBox = root.querySelector('[data-ipv-error]');
  const content = root.querySelector('[data-ipv-content]');
  let finished = false;

  const norm = (value) => String(value || '').toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  const setText = (selector, value) => { const node = root.querySelector(selector); if (node) node.textContent = value || '–'; };
  const setMeta = (selector, value) => { const node = document.head.querySelector(selector); if (node && value) node.setAttribute('content', value); };

  const readAddress = (address) => {
    if (!address) return [];
    const lines = [];
    let current = '';
    address.childNodes.forEach((node) => {
      if (node.nodeName === 'BR') {
        if (current.trim()) lines.push(current.trim());
        current = '';
      } else {
        current += node.textContent || '';
      }
    });
    if (current.trim()) lines.push(current.trim());
    return lines;
  };

  const sectorRules = [
    [/Augenoptiker/i,'Augenoptiker- und Optometristenhandwerks','Sehen, optische Versorgung, Berufsbildung und fachliche Qualitätsstandards'],
    [/Bäcker/i,'Bäckerhandwerks','Backwaren, Rohstoffe, Lebensmittelqualität, Ausbildung und Nachwuchsgewinnung'],
    [/Baugewerbe/i,'Bau- und Ausbauhandwerks','Bautechnik, Vergabe, Unternehmensführung, Fachkräfte und Berufsbildung'],
    [/Bestatter/i,'Bestattungshandwerks','Bestattungskultur, Beratung, Qualifikation, Recht und Qualitätsstandards'],
    [/Büchsenmacher/i,'Büchsenmacherhandwerks','handwerkliche Fertigung, Instandhaltung, Berufsbildung und rechtliche Rahmenbedingungen'],
    [/Buchbinder/i,'Buchbinderhandwerks','Buchgestaltung, Papierverarbeitung, Restaurierung, Ausbildung und handwerkliche Qualität'],
    [/Dachdecker/i,'Dachdeckerhandwerks','Dach-, Wand- und Abdichtungstechnik, Arbeitssicherheit, Ausbildung und Fachregeln'],
    [/Druck und Medien/i,'Druck- und Medienwirtschaft','Drucktechnik, Medienproduktion, Ausbildung, Nachhaltigkeit und Branchenentwicklung'],
    [/Elektro-/i,'Elektro- und informationstechnischen Handwerks','Elektrotechnik, Gebäudesystemtechnik, Digitalisierung, Energiewende und Ausbildung'],
    [/Faltschachtel/i,'Faltschachtel- und Verpackungsindustrie','Verpackungstechnik, Materialien, Nachhaltigkeit, Fachkräfte und Branchenstandards'],
    [/Farbe Gestaltung Bautenschutz/i,'Maler- und Lackiererhandwerks','Farbe, Gestaltung, Bautenschutz, Ausbildung, Technik und Unternehmensführung'],
    [/Fleischer/i,'Fleischerhandwerks','Lebensmittelhandwerk, Qualität, Hygiene, Ausbildung und Nachwuchs'],
    [/Friseur/i,'Friseurhandwerks','Friseurdienstleistungen, Ausbildung, Unternehmertum, Mode und Branchenkommunikation'],
    [/Galvaniseure/i,'Galvaniseur-, Graveur- und Metallbildnerhandwerks','Oberflächentechnik, Gestaltung, Metallbearbeitung, Ausbildung und Fachregeln'],
    [/Garten-, Landschafts-/i,'Garten-, Landschafts- und Sportplatzbaus','Landschaftsbau, Grünflächen, Ausbildung, Technik und nachhaltige Stadtentwicklung'],
    [/Gebäudereiniger/i,'Gebäudereinigerhandwerks','Reinigung, Hygiene, Gebäudedienste, Ausbildung, Tarif- und Branchenfragen'],
    [/Gerüstbau/i,'Gerüstbauerhandwerks','Gerüsttechnik, Arbeitssicherheit, Fachregeln, Ausbildung und Interessenvertretung'],
    [/Getreide-/i,'Getreide-, Mühlen- und Stärkewirtschaft','Rohstoffe, Verarbeitung, Lebensmittelqualität, Ausbildung und Branchenpolitik'],
    [/Glaserhandwerk/i,'Glaserhandwerks','Glas, Fenster, Fassaden, Verglasungstechnik, Ausbildung und Fachregeln'],
    [/Goldschmiede/i,'Gold- und Silberschmiedehandwerks','Schmuckgestaltung, Edelmetalle, handwerkliche Qualität, Ausbildung und Kulturgut'],
    [/Holz- und Bautenschutz/i,'Holz- und Bautenschutzgewerbes','Bauwerkserhaltung, Feuchte- und Holzschutz, Qualifikation und technische Regeln'],
    [/Hörakustiker/i,'Hörakustikerhandwerks','Hörversorgung, Technik, Ausbildung, Qualität und gesundheitspolitische Rahmenbedingungen'],
    [/Kälteanlagenbauer/i,'Kälteanlagenbauerhandwerks','Kälte-, Klima- und Wärmepumpentechnik, Umweltanforderungen, Ausbildung und Fachregeln'],
    [/Karosserie-/i,'Karosserie- und Fahrzeugbauerhandwerks','Fahrzeugbau, Reparaturtechnik, Digitalisierung, Ausbildung und Qualitätsstandards'],
    [/Konditor/i,'Konditorenhandwerks','Feine Backwaren, Gestaltung, Lebensmittelqualität, Ausbildung und Nachwuchs'],
    [/Kraftfahrzeughandwerk/i,'Kraftfahrzeughandwerks','Fahrzeugtechnik, Werkstattpraxis, Mobilität, Ausbildung und Branchenpolitik'],
    [/Kunsthandwerk/i,'Kunsthandwerks und angewandten Designs','Gestaltung, Materialkultur, Märkte, berufliche Sichtbarkeit und handwerkliche Qualität'],
    [/Kürschner/i,'Kürschnerhandwerks','Fellverarbeitung, Gestaltung, Reparatur, Ausbildung und handwerkliche Tradition'],
    [/LandBauTechnik/i,'Land- und Baumaschinentechnik','Landtechnik, Baumaschinen, Werkstattservice, Digitalisierung und Ausbildung'],
    [/Maritime Wirtschaft/i,'maritimen Handwerks und der maritimen Wirtschaft','Boots- und Schiffstechnik, maritime Dienstleistungen, Fachkräfte und Branchenentwicklung'],
    [/Maßschneider/i,'Maßschneiderhandwerks','Schnitt, Passform, Textilverarbeitung, Gestaltung, Ausbildung und Kulturerbe'],
    [/Bundesverband Metall$/i,'Metallhandwerks','Metallbau, Konstruktion, Fertigung, Digitalisierung, Ausbildung und Branchenpolitik'],
    [/Modell- und Formenbau/i,'Modell- und Formenbaus','Modellbau, Formenbau, digitale Fertigung, Ausbildung und industrielle Zusammenarbeit'],
    [/Musikinstrumenten/i,'Musikinstrumentenhandwerks','Instrumentenbau, Reparatur, Klangkultur, Ausbildung und handwerkliches Kulturerbe'],
    [/Orthopädie-Technik/i,'Orthopädietechnik-Handwerks','Hilfsmittelversorgung, Technik, Qualität, Ausbildung und gesundheitspolitische Fragen'],
    [/Orthopädieschuhtechnik/i,'Orthopädieschuhtechnik-Handwerks','individuelle Versorgung, Fußgesundheit, Technik, Ausbildung und Qualität'],
    [/Parkett und Fußbodentechnik/i,'Parkett- und Bodenlegerhandwerks','Bodenaufbau, Holz, Oberflächen, Technik, Ausbildung und Sachverständigenwesen'],
    [/Präzisionswerkzeugmechaniker/i,'Präzisionswerkzeugmechanikerhandwerks','Schneid- und Präzisionswerkzeuge, Fertigung, Digitalisierung, Ausbildung und Qualität'],
    [/Private Brauereien/i,'privaten Brauwirtschaft','Bierkultur, Rohstoffe, Mittelstand, Ausbildung und Branchenpolitik'],
    [/Raum und Ausstattung/i,'Raumausstatter- und Sattlerhandwerks','Innenraumgestaltung, Polsterung, Boden, Sonnenschutz, Ausbildung und Design'],
    [/Reifenhandel/i,'Reifenhandels und Vulkaniseur-Handwerks','Reifentechnik, Fahrzeugsicherheit, Werkstattpraxis, Ausbildung und Branchenstandards'],
    [/Rollladen/i,'Rollladen- und Sonnenschutztechnikerhandwerks','Sonnenschutz, Antriebe, Gebäudeautomation, Energieeffizienz und Ausbildung'],
    [/Sanitär Heizung Klima/i,'Sanitär-, Heizungs- und Klimahandwerks','Wärme, Wasser, Klima, Energiewende, Technik und Ausbildung'],
    [/Schilder und Lichtreklame/i,'Schilder- und Lichtreklameherstellerhandwerks','Werbetechnik, Gestaltung, Licht, Digitalisierung, Ausbildung und Fachregeln'],
    [/Schornsteinfeger/i,'Schornsteinfegerhandwerks','Brandschutz, Energieeffizienz, Anlagensicherheit, Ausbildung und hoheitliche Aufgaben'],
    [/Speiseeishersteller/i,'Speiseeisherstellerhandwerks','Speiseeis, Lebensmittelqualität, Ausbildung, Unternehmertum und Branchenkommunikation'],
    [/Steinmetze/i,'Steinmetz- und Steinbildhauerhandwerks','Naturstein, Baukultur, Denkmalpflege, Grabmalgestaltung, Ausbildung und Fachregeln'],
    [/Textilreinigungs/i,'Textilreinigerhandwerks','Textilpflege, Hygiene, Verfahrenstechnik, Nachhaltigkeit und Ausbildung'],
    [/Tischler Schreiner/i,'Tischler- und Schreinerhandwerks','Holz, Möbel, Innenausbau, Digitalisierung, Ausbildung und Gestaltung'],
    [/Uhren, Schmuck/i,'Uhrmacher- und Schmuckhandwerks','Zeitmesstechnik, Schmuck, Reparatur, Ausbildung und handwerkliche Qualität'],
    [/Zahntechniker/i,'Zahntechnikerhandwerks','zahntechnische Versorgung, Werkstoffe, Digitalisierung, Qualität und Ausbildung'],
    [/Zweirad/i,'Zweiradhandwerks','Fahrrad- und Motorradtechnik, Werkstattpraxis, Mobilität, Ausbildung und Branchenentwicklung']
  ];

  const sectorFor = (name) => {
    for (const [pattern, sector, focus] of sectorRules) if (pattern.test(name)) return { sector, focus };
    return { sector: 'vertretenen Handwerks- und Fachbereichs', focus: 'Fachpolitik, Qualität, Ausbildung, Nachwuchs und Branchenentwicklung' };
  };

  const cardToRecord = (card) => {
    const addressLines = readAddress(card.querySelector('address'));
    const contacts = [...card.querySelectorAll('.zb-directory-card__contact a')];
    const links = [...card.querySelectorAll('.zb-directory-card__links a')];
    const website = links.find((a) => /Website/i.test(a.textContent))?.href || links[0]?.href || '';
    const source = links.find((a) => /Quelle/i.test(a.textContent))?.href || links[1]?.href || website;
    return {
      type: profileType,
      name: card.querySelector('h3')?.textContent.trim() || wantedTitle,
      trade: card.querySelector('.zb-directory-card__trade')?.textContent.trim() || '',
      street: addressLines[0] || '',
      zipCity: addressLines[1] || '',
      state: addressLines[2] || '',
      phone: contacts.find((a) => a.href.startsWith('tel:'))?.textContent.trim() || '',
      email: contacts.find((a) => a.href.startsWith('mailto:'))?.textContent.trim() || '',
      website,
      source
    };
  };

  const buildProfile = (record) => {
    const city = record.zipCity.replace(/^\S+\s+/, '') || record.zipCity || 'der Geschäftsstelle';
    if (record.type === 'HWK') {
      return {
        label: 'Handwerkskammer', short: record.name.replace(/^Handwerkskammer\s+/i, 'HWK '),
        area: `Kammerbezirk in ${record.state}`, trade: 'Gesamtes Handwerk im regionalen Kammerbezirk',
        summary: `${record.name} ist die regionale Selbstverwaltungs-, Interessen- und Serviceorganisation des Handwerks mit Sitz in ${city}. Dieses Profil bündelt offizielle Kontaktdaten, Website-Screenshot und die wichtigsten Wege für Betriebe, Auszubildende, Meisterinnen und Meister, Gründungsinteressierte und Verbraucher.`,
        about: `${record.name} vertritt das Gesamthandwerk ihres Kammerbezirks in ${record.state}. Sie verbindet gesetzlich übertragene Aufgaben der handwerklichen Selbstverwaltung mit Berufsbildung, Beratung und Interessenvertretung. Für Betriebe ist sie Anlaufstelle unter anderem bei Eintragung, Ausbildung, Unternehmensführung, Digitalisierung und Nachfolge; für Nachwuchs und Fachkräfte eröffnet sie Wege zu Ausbildung, Meisterqualifikation und Weiterbildung.`,
        servicesTitle: `Aufgaben und Angebote der ${record.name.replace(/^Handwerkskammer\s+/i, 'HWK ')}`,
        services: [
          ['01','Handwerksrolle & Selbstverwaltung','Eintragung, handwerksrechtliche Zuständigkeiten und Selbstverwaltung des Handwerks im Kammerbezirk.'],
          ['02','Ausbildung & Prüfungen','Ausbildungsberatung, Lehrlingsrolle, Gesellen- und Abschlussprüfungen sowie Unterstützung von Ausbildungsbetrieben.'],
          ['03','Meister & Weiterbildung','Meisterprüfung, Vorbereitung, Fortbildungsabschlüsse, Bildungszentren und berufliche Aufstiegswege.'],
          ['04','Betrieb, Gründung & Nachfolge','Betriebswirtschaftliche, technische und rechtliche Beratung zu Gründung, Finanzierung, Personal, Digitalisierung und Nachfolge.'],
          ['05','Innungen & Interessenvertretung','Verbindung zu Innungen und Kreishandwerkerschaften sowie Vertretung handwerklicher Belange gegenüber Politik und Verwaltung.'],
          ['06','Verbraucher & Fachbetriebe','Wege zu Fachbetriebssuche, Sachverständigen, Verbraucherinformationen und weiteren öffentlich angebotenen Diensten.']
        ],
        audiences: [
          ['Handwerksbetriebe','Handwerksrolle, Beratung, Unternehmensführung, Nachfolge, Fachkräfte und regionale Ansprechpartner finden.'],
          ['Auszubildende & Meister','Ausbildung, Prüfungen, Meisterqualifikation, Weiterbildung und Karrierewege im Handwerk aufrufen.'],
          ['Gründer, Verbraucher & Schulen','Gründungshilfe, Fachbetriebssuche und verlässliche regionale Informationen direkt bei der Kammer erreichen.']
        ],
        sourceCopy: 'Kontaktdaten und Website werden aus dem offiziellen Handwerkskammer-Verzeichnis übernommen. Aufgaben und Zuständigkeit sind redaktionell eingeordnet.',
        disclaimer: 'Die dargestellten Aufgaben entsprechen der typischen gesetzlichen Rolle der Handwerkskammern. Konkrete Zuständigkeiten und Angebote können regional abweichen; verbindlich ist die offizielle Website.'
      };
    }
    if (record.type === 'IHK') {
      return {
        label: 'Industrie- und Handelskammer', short: record.name.replace(/^Industrie- und Handelskammer\s+/i, 'IHK '),
        area: `Regionaler IHK-Bezirk in ${record.state}`, trade: 'Industrie, Handel & Dienstleistungen',
        summary: `${record.name} ist die regionale Selbstverwaltungs- und Interessenorganisation der gewerblichen Wirtschaft mit Sitz in ${city}. Das Profil bündelt Website-Screenshot, Kontakt, Zuständigkeit und zentrale Wege für Unternehmen, Auszubildende, Gründer und weitere Interessierte.`,
        about: `${record.name} vertritt Unternehmen aus Industrie, Handel und Dienstleistungen in ihrem Bezirk. Sie verbindet gesetzlich übertragene Aufgaben mit Berufsbildung, Prüfungswesen, Unternehmensservice und wirtschaftspolitischer Interessenvertretung. Hinzu kommen je nach Angebot Gründung, Weiterbildung, Außenwirtschaft, Innovation, Digitalisierung und regionale Standortfragen.`,
        servicesTitle: 'Aufgaben und Angebote der IHK',
        services: [
          ['01','Ausbildung & Prüfungen','Eintragung und Betreuung von Ausbildungsverhältnissen, Ausbildungsberatung sowie Organisation von Zwischen- und Abschlussprüfungen.'],
          ['02','Gründung & Unternehmensservice','Orientierung rund um Gründung, Unternehmensführung, Finanzierung, Nachfolge und wirtschaftliche Rahmenbedingungen.'],
          ['03','Standort & Interessenvertretung','Vertretung der regionalen gewerblichen Wirtschaft gegenüber Politik und Verwaltung sowie Mitwirkung an Standort- und Infrastrukturfragen.'],
          ['04','Außenwirtschaft & Internationales','Informationen zu Export, Import, Auslandsmärkten, Zoll- und Außenwirtschaftsthemen sowie internationalen Geschäftskontakten.'],
          ['05','Innovation & Digitalisierung','Unterstützung zu Innovation, Digitalisierung, Energie, Nachhaltigkeit und technologischen Veränderungen.'],
          ['06','Weiterbildung & Netzwerk','Weiterbildungsangebote, Veranstaltungen, Branchenkontakte und regionale Unternehmensnetzwerke.']
        ],
        audiences: [
          ['Unternehmen & Gründer','Unternehmensservice, Gründung, Standort, Außenwirtschaft und regionale Ansprechpartner erreichen.'],
          ['Auszubildende & Prüflinge','Ausbildungsberatung, Prüfungsinformationen, Weiterbildung und berufliche Entwicklung finden.'],
          ['Wirtschaft, Politik & Öffentlichkeit','Regionale Wirtschaftsinteressen, Standortthemen und offizielle Informationen der zuständigen IHK einordnen.']
        ],
        sourceCopy: 'Kontaktdaten und Website werden aus dem offiziellen IHK-Finder übernommen. Aufgaben und regionale Rolle sind redaktionell eingeordnet.',
        disclaimer: 'Die konkrete Zuständigkeit und einzelne Leistungen unterscheiden sich regional. Verbindlich sind die aktuellen Angaben der jeweiligen IHK.'
      };
    }
    const { sector, focus } = sectorFor(record.name);
    return {
      label: 'Innung / Fachverband', short: record.name,
      area: record.state === 'Bundesweit' ? `Bundesweite Fachorganisation · Geschäftsstelle in ${city}` : `${record.state} · Sitz in ${city}`,
      trade: sector.charAt(0).toUpperCase() + sector.slice(1),
      summary: `${record.name} ist eine Fachorganisation des ${sector}. Das Profil führt Betriebe, Innungen, Landesverbände, Auszubildende, Schulen und interessierte Besucher direkt zu den offiziellen Kontaktdaten, zum Website-Screenshot und zu den zentralen Aufgaben der Organisation.`,
      about: `Vom Sitz in ${city} aus bündelt ${record.name} fachliche und wirtschaftliche Anliegen des ${sector}. Je nach Verbandsstruktur vernetzt die Organisation Innungen, Landesverbände, Betriebe und weitere Fachakteure, bereitet Brancheninformationen auf und vertritt gemeinsame Positionen gegenüber Politik, Verwaltung, Wirtschaft und Öffentlichkeit. Inhaltliche Schwerpunkte sind insbesondere ${focus}.`,
      servicesTitle: 'Aufgaben und fachlicher Mehrwert',
      services: [
        ['01','Fachpolitik & Interessenvertretung',`Bündelung und Vertretung gemeinsamer Anliegen des ${sector} gegenüber Politik, Behörden, Wirtschaft und Öffentlichkeit.`],
        ['02','Ausbildung & Nachwuchs',`Berufsbilder, Ausbildungswege, Prüfungsfragen, Weiterbildung und Nachwuchsgewinnung im ${sector}.`],
        ['03','Technik, Qualität & Fachwissen',`Fachinformationen zu ${focus} sowie Hinweise zu Standards und Branchenentwicklung, soweit offiziell angeboten.`],
        ['04','Innungen, Verbände & Netzwerk','Vernetzung regionaler Organisationen und Betriebe sowie Wege zu Landesverbänden, Innungen und Fachstellen.'],
        ['05','Weiterbildung & Veranstaltungen','Seminare, Fachtagungen, Messen, Publikationen und weitere Qualifizierungs- oder Informationsangebote der Organisation.'],
        ['06','Branche & Öffentlichkeit','Pressearbeit, Kampagnen, Fachkommunikation und Orientierung für Mitglieder, Nachwuchs, Partner und Öffentlichkeit.']
      ],
      audiences: [
        ['Mitgliedsbetriebe & Innungen','Fachinformationen, Interessenvertretung, Verbandsstruktur, Ansprechpartner und Netzwerkwege finden.'],
        ['Nachwuchs & Fachkräfte','Ausbildungsberufe, Weiterbildung, Karriereinformationen und branchenspezifische Orientierung erreichen.'],
        ['Schulen, Partner & Öffentlichkeit','Die Rolle des Fachverbands einordnen und direkt zu offiziellen Informationen und Ansprechpartnern wechseln.']
      ],
      sourceCopy: 'Kontaktdaten und Website werden aus dem offiziellen Zentralfachverbands-Verzeichnis des Handwerks übernommen. Fachgebiet und Aufgaben sind redaktionell eingeordnet.',
      disclaimer: 'Verbandsstruktur und konkrete Leistungen unterscheiden sich je Organisation. Verbindlich sind ausschließlich die aktuellen Angaben auf der offiziellen Website.'
    };
  };

  const renderCards = (selector, items, className) => {
    const container = root.querySelector(selector);
    if (!container) return;
    container.replaceChildren(...items.map((item) => {
      const article = document.createElement('article');
      article.className = className;
      if (className === 'ipv-service') {
        const number = document.createElement('span'); number.setAttribute('aria-hidden','true'); number.textContent = item[0];
        const heading = document.createElement('h3'); heading.textContent = item[1];
        const copy = document.createElement('p'); copy.textContent = item[2];
        article.append(number, heading, copy);
      } else {
        const strong = document.createElement('strong'); strong.textContent = item[0];
        const copy = document.createElement('p'); copy.textContent = item[1];
        article.append(strong, copy);
      }
      return article;
    }));
    if (selector === '[data-ipv-services]') container.dataset.editorial = 'true';
  };

  const injectSchema = (record, profile, imageUrl) => {
    document.getElementById('ipv-organization-schema')?.remove();
    document.getElementById('ipv-breadcrumb-schema')?.remove();
    const org = document.createElement('script');
    org.id = 'ipv-organization-schema'; org.type = 'application/ld+json';
    org.textContent = JSON.stringify({
      '@context':'https://schema.org','@type':'Organization','@id':`${location.origin}${location.pathname}#organization`,
      name:record.name,url:record.website,description:profile.summary,telephone:record.phone||undefined,email:record.email||undefined,
      image:imageUrl||undefined,areaServed:record.state||undefined,sameAs:record.website?[record.website]:undefined,
      address:{'@type':'PostalAddress',streetAddress:record.street||undefined,addressLocality:record.zipCity||undefined,addressRegion:record.state||undefined,addressCountry:'DE'}
    });
    document.head.appendChild(org);
    const crumb = document.createElement('script');
    crumb.id = 'ipv-breadcrumb-schema'; crumb.type = 'application/ld+json';
    crumb.textContent = JSON.stringify({'@context':'https://schema.org','@type':'BreadcrumbList',itemListElement:[
      {'@type':'ListItem',position:1,name:'Innungs- und Kammerverzeichnis',item:`${location.origin}${root.dataset.portalUrl}`},
      {'@type':'ListItem',position:2,name:record.name,item:`${location.origin}${location.pathname}`}
    ]});
    document.head.appendChild(crumb);
  };

  const preservePreview = (path) => {
    const target = new URL(path, location.origin);
    const id = new URL(location.href).searchParams.get('preview_theme_id');
    if (id) target.searchParams.set('preview_theme_id', id);
    return target.pathname + target.search + target.hash;
  };

  const render = (record) => {
    if (finished) return;
    const profile = buildProfile(record);
    const image = root.querySelector('[data-ipv-shot]');
    const fallback = root.querySelector('[data-ipv-shot-fallback]');
    const imageUrl = image && !image.hidden ? (image.currentSrc || image.src || '') : '';

    setText('[data-ipv-eyebrow]', `${profile.label} · ${record.state === 'Bundesweit' ? 'Deutschland' : record.state}`);
    setText('[data-ipv-name]', record.name);
    setText('[data-ipv-lead]', profile.summary);
    setText('[data-ipv-region]', record.state === 'Bundesweit' ? 'Deutschland / bundesweit' : record.state);
    setText('[data-ipv-domain]', record.website ? new URL(record.website).hostname.replace(/^www\./,'') : 'Offizielle Website');
    setText('[data-ipv-about-title]', `Über ${profile.short}`);
    setText('[data-ipv-description]', profile.about);
    setText('[data-ipv-type]', profile.label);
    setText('[data-ipv-area]', profile.area);
    setText('[data-ipv-seat]', record.zipCity);
    setText('[data-ipv-trade]', profile.trade);
    setText('[data-ipv-services-title]', profile.servicesTitle);
    setText('[data-ipv-disclaimer]', profile.disclaimer);
    setText('[data-ipv-short-name]', profile.short);
    setText('[data-ipv-street]', record.street);
    setText('[data-ipv-cityline]', record.zipCity);
    setText('[data-ipv-state]', record.state);
    setText('[data-ipv-source-copy]', profile.sourceCopy);

    const tradeRow = root.querySelector('[data-ipv-trade-row]'); if (tradeRow) tradeRow.hidden = false;
    renderCards('[data-ipv-services]', profile.services, 'ipv-service');
    renderCards('[data-ipv-audiences]', profile.audiences, 'ipv-audience');

    root.querySelectorAll('[data-ipv-website],[data-ipv-website-side],[data-ipv-shot-link]').forEach((a) => { a.href = record.website; });
    const phone = root.querySelector('[data-ipv-phone]');
    if (phone) { if (record.phone) { phone.hidden = false; phone.href = `tel:${record.phone.replace(/[^\d+]/g,'')}`; phone.textContent = `Telefon: ${record.phone}`; } else phone.hidden = true; }
    const email = root.querySelector('[data-ipv-email]');
    if (email) { if (record.email) { email.hidden = false; email.href = `mailto:${record.email}`; email.textContent = `E-Mail: ${record.email}`; } else email.hidden = true; }
    const source = root.querySelector('[data-ipv-source]'); if (source) source.href = record.source || record.website;

    if (imageUrl) {
      image.hidden = false;
      image.alt = image.alt || `Screenshot der offiziellen Website von ${record.name}`;
      if (fallback) fallback.hidden = true;
      setMeta('meta[property="og:image"]', imageUrl);
      setMeta('meta[name="twitter:image"]', imageUrl);
    } else if (fallback) fallback.hidden = false;

    const claim = new URL(root.dataset.claimUrl, location.origin);
    claim.searchParams.set('organisation', record.name);
    claim.searchParams.set('website', record.website);
    claim.searchParams.set('profil', location.href);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) claim.searchParams.set('preview_theme_id', preview);
    root.querySelectorAll('[data-ipv-claim],[data-ipv-claim-side],[data-ipv-claim-bottom]').forEach((a) => { a.href = claim.pathname + claim.search; });
    root.querySelectorAll('.ipv-back,.ipv-error a').forEach((a) => { a.href = preservePreview(root.dataset.portalUrl); });

    injectSchema(record, profile, imageUrl);
    root.querySelectorAll('a[href^="#"]').forEach((a) => a.addEventListener('click', (event) => {
      const target = root.querySelector(a.getAttribute('href')); if (!target) return;
      event.preventDefault(); target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    }));

    finished = true;
    root.dataset.profileReady = 'true';
    if (loading) loading.hidden = true;
    if (errorBox) errorBox.hidden = true;
    if (content) content.hidden = false;
  };

  const findRecord = () => {
    const cards = [...sourceRoot.querySelectorAll('.zb-directory-card')];
    const card = cards.find((item) => norm(item.querySelector('h3')?.textContent) === norm(wantedTitle === 'Spitzenverband Orthopädieschuhtechnik (SpiOST)' ? 'Spitzenverband für Orthopädie-Schuhtechnik e. V.' : wantedTitle));
    return card ? cardToRecord(card) : null;
  };

  const fail = () => {
    if (finished) return;
    if (loading) loading.hidden = true;
    if (content) content.hidden = true;
    if (errorBox) errorBox.hidden = false;
    root.querySelectorAll('.ipv-error a').forEach((a) => { a.href = preservePreview(root.dataset.portalUrl); });
  };

  const boot = () => {
    const record = findRecord();
    if (record?.website) { render(record); return; }
    const results = sourceRoot.querySelector('[data-zb-dir-results]');
    if (!results) { fail(); return; }
    const observer = new MutationObserver(() => {
      const next = findRecord();
      if (next?.website) { observer.disconnect(); render(next); }
    });
    observer.observe(results, {childList:true,subtree:true});
    window.setTimeout(() => { observer.disconnect(); if (!finished) fail(); }, 5000);
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, {once:true}) : boot();
})();

